// extracted by mini-css-extract-plugin
export default {"lister":"StoreData_lister__b1KbX","list":"StoreData_list__pjCsa","content":"StoreData_content__f0OQu","select":"StoreData_select__C1U4E","image":"StoreData_image__I2X5u"};